<p-tabs styleClass="service-provider-panel" [value]="0" lazy>
  <p-tablist>
    <p-tab [value]="0">General Information</p-tab>
    @if (!isExternalUser) {
      <p-tab [value]="1">Service Provider History</p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <div class="grid grid-cols-12 gap-4 p-fluid p-form-view-data">
        <div class="col-span-12 md:col-span-4">
          <div class="card-grid small-gap">
            <label>Parent Company Name:</label>
            <div>
              {{ providerCombineData?.parentCompany | emptyPlaceholder }} 
            </div>

            <label>NPI:</label>
            <div>
              {{ providerCombineData?.npi }}
            </div>

            @if (!isExternalUser) {
              <label>Portal Provider ID:</label>
              <div>{{ providerCombineData?.portalProviderId | emptyPlaceholder }}</div>
            }

            @if (!isExternalUser) {
              <label>Client Provider ID:</label>
              <div>{{ providerCombineData?.clientProviderId | emptyPlaceholder }}</div>
            }

            <label>Out of Network:</label>
            <div class="p-field-checkbox-container">
              <p-checkbox
                binary="true"
                [disabled]="true"
                [ngModel]="providerCombineData?.participationStatus"
              ></p-checkbox>
            </div>

            <label class="self-center">Network:</label>
            <div class="flex">
              @if (!isNetworkEditable && !isParticipatingNetworksNeeded) {
                <ng-container
                  class="flex"
                  >
                  <div class="flex items-center">
                    <span>{{ providerCombineData?.participatingNetworks }}</span>
                    <ng-container
                    *accessController="[
                      'AppealGrievance',
                      'OperationsAdmin',
                      'Operations',
                      'Internal',
                      'LetterMapsManager'
                    ]"
                      >
                      @if (!isExternalUser) {
                        <button
                          pButton
                          severity="secondary"
                          type="button"
                          label="Update"
                          class="ml-4 network-field-controls"
                          [disabled]="isNetworkDisabled  || !hasNetworkUpdatePermission"
                          (click)="isNetworkEditable = true"
                        ></button>
                      }
                    </ng-container>
                  </div>
                </ng-container>
              }
              @if (isNetworkEditable || isParticipatingNetworksNeeded) {
                <p-select
                  placeholder="Select"
                  appendTo="body"
                  [options]="networkOption"
                  class="left-spacing"
                  (onChange)="selectNetwork($event)"
                  required
                ></p-select>
                @if (!isParticipatingNetworksNeeded) {
                  <button
                    pButton
                    type="button"
                    label="Cancel"
                    class="p-button-secondary ml-4 network-field-controls"
                    (click)="isNetworkEditable = false"
                  ></button>
                }
                <button
                  pButton
                  type="button"
                  class="network-field-controls ml-4"
                  label="Save"
                  (click)="updateCurrentAuthorization()"
                ></button>
              }
            </div>

            @if (!isExternalUser) {
              <label>Reimbursement Structure:</label>
              @if (tenantName === 'Humana') {
                <div>
                  {{
                  providerCombineData?.reimbursementType === 'Episodic'
                  ? 'Medicare'
                  : providerCombineData?.reimbursementType === 'MED'
                  ? 'Medicare'
                  : providerCombineData?.reimbursementType
                  }}
                </div>
              } @else {
                <div>
                  {{
                  providerCombineData?.reimbursementType === 'MED'
                  ? 'Medicare'
                  : providerCombineData?.reimbursementType
                  }}
                </div>
              }
            }

            @if (!isExternalUser) {
              <label>Review Period Exception:</label>
              <ng-container>
                <div>
                  {{
                  provider.providerPgpDTO.reviewPeriodException
                  ? 'Yes'
                  : 'No'
                  }}
                </div>
              </ng-container>
            }

            <label>Tax ID:</label>
            <div class="readonly-field">
              {{ providerCombineData?.taxId | emptyPlaceholder }}
            </div>

            <label>CMS Number:</label>
            <div class="readonly-field">
              {{ providerCombineData?.cmsnumber | emptyPlaceholder }}
            </div>

            <label>Medicaid Number:</label>
            <div class="readonly-field">
              {{ providerCombineData?.medicaidNumber | emptyPlaceholder }}
            </div>

            @if (!isExternalUser) {
              <label>Telehealth Approved:</label>
              <div class="p-field-checkbox-container">
                <p-checkbox
                  binary="true"
                  [disabled]="true"
                  [ngModel]="!!providerCombineData?.telehealthApprovedDate"
                ></p-checkbox>
              </div>
              <label>Telehealth Approved Date:</label>
              <div class="readonly-field">
                {{
                providerCombineData?.telehealthApprovedDate
                | date : 'MM/dd/yyyy'
                | emptyPlaceholder
                }}
              </div>
              <label>Virtual Visits Approved:</label>
              <div class="p-field-checkbox-container">
                <p-checkbox
                  binary="true"
                  [disabled]="true"
                  [ngModel]="!!providerCombineData?.virtualVisitsApprovedDate"
                ></p-checkbox>
              </div>
              <label>Virtual Visits Approved Date:</label>
              <div class="readonly-field">
                {{
                providerCombineData?.virtualVisitsApprovedDate
                | date : 'MM/dd/yyyy'
                | emptyPlaceholder
                }}
              </div>
            }
          </div>
        </div>

        <!-- Right column -->
        <div class="col-span-12 md:col-span-8">
          <label class="normal-font-size-bold flex mb-1"
            >Address Information</label
            >
            <div class="card-grid small-gap">
              <label>Street:</label>
              <div class="readonly-field">
                {{ providerCombineData?.physicalStreet | emptyPlaceholder }}
              </div>

              <label>City:</label>
              <div>
                {{ providerCombineData?.physicalCity | emptyPlaceholder }}
              </div>

              <label>State:</label>
              <div>
                {{ providerCombineData?.physicalState | emptyPlaceholder }}
              </div>

              <label>Zip Code:</label>
              <div>
                {{ providerCombineData?.physicalZip | emptyPlaceholder }}
              </div>
            </div>

            <label class="normal-font-size-bold flex mt-8 mb-1"
              >Location Information</label
              >
              <div class="card-grid small-gap">
                <label>Phone: </label>
                <div class="readonly-field">
                  {{
                  providerCombineData?.locationPhone
                  | phoneNumber
                  | emptyPlaceholder
                  }}
                </div>

                <label>Fax:</label>
                <div>
                  {{
                  providerCombineData?.locationFax
                  | phoneNumber
                  | emptyPlaceholder
                  }}
                </div>

                <label>Fax Confirmed?:</label>
                <div class="p-field-checkbox-container">
                  <p-checkbox
                    binary="true"
                    [disabled]="true"
                    [ngModel]="providerCombineData?.locationFaxConfirmed"
                  ></p-checkbox>
                </div>

                <label>Fax Confirmed Date:</label>
                <div class="readonly-field">
                  {{
                  providerCombineData?.faxConfirmedDate
                  | date : 'MM/dd/yyyy'
                  | emptyPlaceholder
                  }}
                </div>

                @if (!isExternalUser) {
                  <ng-container class="field">
                    <label>Parent Company Note:</label>
                    <div class="readonly-field">
                      {{ providerCombineData?.parentCompanyNote | emptyPlaceholder }}
                    </div>
                  </ng-container>
                }
              </div>

              <label class="normal-font-size-bold flex mt-8 mb-1"
                >Authorization Information</label
                >
                <div class="card-grid small-gap">
                  <label>Phone:</label>
                  <div class="readonly-field">
                    {{
                    providerCombineData?.authorizationPhone
                    | phoneNumber
                    | emptyPlaceholder
                    }}
                  </div>

                  <label>Fax:</label>
                  <div class="readonly-field">
                    {{
                    providerCombineData?.authorizationFax
                    | phoneNumber
                    | emptyPlaceholder
                    }}
                  </div>

                  <label>Fax Confirmed?:</label>
                  <div class="p-field-checkbox-container">
                    <p-checkbox
                      binary="true"
                      [disabled]="true"
                      [ngModel]="providerCombineData?.authorizationFaxConfirmed"
                    ></p-checkbox>
                  </div>

                  <label>Fax Confirmed Date:</label>
                  <div class="readonly-field">
                    {{
                    providerCombineData?.authorizationFaxConfirmedDate
                    | date : 'MM/dd/yyyy'
                    | emptyPlaceholder
                    }}
                  </div>
                </div>
        </div>
      </div>
    </p-tabpanel>

    @if (!isExternalUser) {
      <p-tabpanel [value]="1">
        <ng-template #content>
          <app-provider-history-table
            [authNumber]="authNumber"
            [providerAccountId]="providerAccountId"
            [tenantId]="tenantId"
          ></app-provider-history-table>
        </ng-template>
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
